import React, { ReactElement } from 'react';
import {
  FormGroup, Heading, Loader, LoaderButton, Select,
} from 'idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import LegislativnyMaterialCreateUpdate from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import useValidPolozkyCiselnik from '../../../../hooks/usePolozkyCiselnik';
import LegMaterialCreateStepEnum from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import PolozkaCiselnik from '../../../../model/ciselniky/PolozkaCiselnik';
import { useUserContext } from '../../../../context/UserContext';
import { UserRoleEnum } from '../../../../model/currentuser/UserRole';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  onUpdateField: SafeParameterSetter<LegislativnyMaterialCreateUpdate>;
  loading: boolean;
  getFieldErrorMessage: (fieldName: string) => string;
}

const TypMaterialuStepOne = ({
  onChangeStep,
  onUpdateField,
  legislativnyMaterial,
  loading,
  getFieldErrorMessage,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();
  const {
    polozkyCiselnik: typMaterialuList,
    polozkyCiselnikStatus: typMaterialuListStatus,
  } = useValidPolozkyCiselnik(
    null,
    [TypCiselnikaEnum.TypMaterialu],
    true,
    null,
  );

  const filterTypMaterialuByRole = (): PolozkaCiselnik [] => {
    if (pouzivatel.roles.includes(UserRoleEnum.PREDKLADATEL_NELEG)
      && pouzivatel.roles.includes(UserRoleEnum.PREDKLADATEL_LEG)) {
      return typMaterialuList;
    }

    return pouzivatel.roles.includes(UserRoleEnum.PREDKLADATEL_LEG) ? typMaterialuList?.filter(typ => typ.legislativny)
      : typMaterialuList?.filter(typ => !typ.legislativny);
  };

  return (
    <div>
      <Heading className="page-title" size="xl">
        Zvoľte typ materiálu
      </Heading>
      <Loader loading={typMaterialuListStatus.loading}>
        <FormGroup>
          <Select
            id="typUuid"
            width="one-half"
            name="typUuid"
            value={legislativnyMaterial.typ.uuid}
            onChange={({ target }) => {
              const selectedTyp = typMaterialuList.find(typMaterialu => typMaterialu.uuid === target.value);
              onUpdateField('typ', selectedTyp);
            }}
            error={getFieldErrorMessage('typUuid')}
          >
            <option key="Vyberte" value="" hidden>Vyberte</option>
            {(filterTypMaterialuByRole() && filterTypMaterialuByRole()?.length > 0) ? (
              <>
                {filterTypMaterialuByRole()
                  ?.map(typ => (
                    <option
                      key={typ.uuid}
                      value={typ.uuid}
                    >
                      {typ.nazov}
                    </option>
                  ))}
              </>
            ) : (
              <option key="emptyOption" value="emptyOption" disabled>
                Nenašiel sa žiadny záznam.
              </option>
            )}
          </Select>
        </FormGroup>
      </Loader>
      <LoaderButton
        size="large"
        className="legislativny-material-create__submit-button"
        loading={loading}
        type="submit"
        onClick={() => onChangeStep(LegMaterialCreateStepEnum.BASIC_DATA_2)}
        disableOutsideClickWhileLoading
      >Pokračovať
      </LoaderButton>
    </div>
  );
};

export default TypMaterialuStepOne;
